import { StaticImageData } from 'next/image';
import React from 'react';
import styled from 'styled-components';

import theme from '../../assets/theme';

interface SupportedTestPrepCardProps {
  image: StaticImageData;
  alt: string;
  firstSectionTitle: string;
  firstSectionItems: string[];
  secondSectionTitle: string;
  secondSectionItems: string[];
}

const CardContainer = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 450px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.13);
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;
  text-align: left;
`;

const CardImage = styled.img`
  width: 100%;
  max-width: 189px;
  border-radius: 10px;
  margin-bottom: 30px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const SectionTitle = styled.p`
  margin: 0;
  font-size: 18px;

  strong {
    font-weight: 800;
  }
`;

const ItemList = styled.ul<{ hasMarginBottom?: boolean }>`
  padding-left: 24px;
  margin-bottom: ${props => (props.hasMarginBottom ? '20px' : '0')};
`;

const ListItem = styled.li`
  font-size: 16px;
  color: ${theme.colors.black};
  font-weight: 600;
`;

const SupportedTestPrepCard: React.FC<SupportedTestPrepCardProps> = ({
  image,
  alt,
  firstSectionTitle,
  firstSectionItems,
  secondSectionTitle,
  secondSectionItems,
}) => {
  return (
    <CardContainer>
      <CardImage src={image.src} alt={alt} />

      <SectionTitle>
        <strong>{firstSectionTitle}</strong>
      </SectionTitle>
      <ItemList hasMarginBottom>
        {firstSectionItems.map((item, index) => (
          <ListItem key={index}>{item}</ListItem>
        ))}
      </ItemList>

      <SectionTitle>
        <strong>{secondSectionTitle}</strong>
      </SectionTitle>
      <ItemList>
        {secondSectionItems.map((item, index) => (
          <ListItem key={index}>{item}</ListItem>
        ))}
      </ItemList>
    </CardContainer>
  );
};

export default SupportedTestPrepCard;
